export const PatientFolderActions = {
    ALL_FOLDERS_UPDATE: "ALL_FOLDERS_UPDATE",
    PAGE_UPDATE: "PAGE_UPDATE",
    TOTAL_PAGES_UPDATE: "TOTAL_PAGES_UPDATE",
    TOTAL_COUNT_UPDATE: "TOTAL_COUNT_UPDATE",
    SEARCH_PARAMS_UPDATE: "SEARCH_PARAMS_UPDATE",
    SEARCH_PARAMS_CLEAR: "SEARCH_PARAMS_CLEAR",
    ALL_TAGS_UPDATE: "ALL_TAGS_UPDATE",
}